import { injectable } from 'inversify';

import { Offset } from '../../interfaces/Offset';
import { GeocoderEntry } from '../../interfaces/search/GeocoderEntry';
import { SearchEntries } from '../../interfaces/search/SearchEntries';
import { MapStorage } from '../../interfaces/storage/MapStorage';
import { ResultsStorage } from '../../interfaces/storage/ResultsStorage';
import { isGeocoderEntry, isLatLngLiteral } from '../guards';

@injectable()
export class SearchStorage implements ResultsStorage {
	public filters!: string[];
	public geocoding!: GeocoderEntry[];
	public map!: MapStorage;
	public results!: SearchEntries;
	public searchCenter!: ym.provider.LatLngLiteral;
	public searchTerm = '';
	public offset!: Offset;
	public isInitial = false;

	constructor() {
		this.map = { position: { lat: NaN, lng: NaN }, zoom: NaN };
		this.results = {
			type: 'SearchEntries',
			entries: [],
			fitBounds: false,
			geocoding: []
		};
		this.filters = [];
		this.offset = {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		};
	}

	public setResults(results: SearchEntries, userSearch = false): void {
		this.results = results;
		if (userSearch) {
			this.geocoding = this.results.geocoding;
			if (isLatLngLiteral(this.results.center)) {
				this.searchCenter = this.results.center;
			} else if (isGeocoderEntry(this.geocoding[0])) {
				this.searchCenter = this.geocoding[0].position;
			}
		}
	}

	public setMap(map: ym.provider.MapContext): void {
		const { lat, lng } = map.getCenter();
		this.map.position = { lat, lng };
		this.map.zoom = map.getZoom();
	}
}
